import React, { forwardRef } from "react"
import { IconButton as MUIIconButton, IconButtonProps } from "@mui/material"
import { useStyles } from "./styles"
import Tooltip from "../Tooltip"

export type Props = Omit<IconButtonProps, "size"> & {
  to?: string
  size?: "xsmall" | "small" | "medium" | "large"
  variant?: "default" | "outlined" | "solid"
  squareHover?: boolean
  tooltipText?: string
}

const IconButton: React.FC<Props> = forwardRef<HTMLButtonElement, Props>(
  ({ size, variant = "default", squareHover, tooltipText, ...props }, ref) => {
    const { classes } = useStyles({ variant, squareHover })

    const button = (
      <MUIIconButton
        ref={ref}
        disableRipple
        size={size as IconButtonProps["size"]}
        classes={classes}
        {...props}
      />
    )

    if (tooltipText) {
      return <Tooltip title={tooltipText}>{button}</Tooltip>
    }

    return button
  }
)
export default IconButton
